import React from "react";
import { Link } from "react-router-dom";

import DashboardBreadcrumbs from "components/DashboardBreadcrumbs";

import { useCountryData } from "lib/config";

export default function CountryLevelBreadcrumbs({ country }) {
  const countryData =  useCountryData(country);
  return (
    <DashboardBreadcrumbs aria-label="breadcrumb">
      <Link to={`/distancing`} style={{ color: "inherit" }}>
        Latam
      </Link>
      {countryData.name}
    </DashboardBreadcrumbs>
  );
}
